import { useMutation } from "@tanstack/react-query";
import { collection, doc, setDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
import { useInvalidateCalendarsForTables } from "./useCalendarsForTables";
import Calendar from "../../models/calendars/Calendar";

export function useCreateCalendar() {
  const invalidateCalendarTable = useInvalidateCalendarsForTables();

  return useMutation({
    mutationFn: async (data) => {
      const calendarRef = doc(collection(db, "calendars"));

      const calendarData = Calendar.toJSON({ ...data, id: calendarRef.id });
      await setDoc(calendarRef, calendarData);

      return { success: true, id: calendarRef.id };
    },
    onSuccess: (_result, _variables) => {
      invalidateCalendarTable();
    },
    onError: (err) => {
      console.error("Failed to create calendar:", err);
    },
  });
}
